import { useEffect } from "react";
import { Marker, useMap, useMapEvents } from "react-leaflet";
import useSupercluster from "use-supercluster";

const markerIcon = new L.divIcon({
  html: `<?xml version="1.0" ?><svg height="24" version="1.1" width="24" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><g transform="translate(0 -1028.4)"><path d="m12.031 1030.4c-3.8657 0-6.9998 3.1-6.9998 7 0 1.3 0.4017 2.6 1.0938 3.7 0.0334 0.1 0.059 0.1 0.0938 0.2l4.3432 8c0.204 0.6 0.782 1.1 1.438 1.1s1.202-0.5 1.406-1.1l4.844-8.7c0.499-1 0.781-2.1 0.781-3.2 0-3.9-3.134-7-7-7zm-0.031 3.9c1.933 0 3.5 1.6 3.5 3.5 0 2-1.567 3.5-3.5 3.5s-3.5-1.5-3.5-3.5c0-1.9 1.567-3.5 3.5-3.5z" fill="#c0392b"/><path d="m12.031 1.0312c-3.8657 0-6.9998 3.134-6.9998 7 0 1.383 0.4017 2.6648 1.0938 3.7498 0.0334 0.053 0.059 0.105 0.0938 0.157l4.3432 8.062c0.204 0.586 0.782 1.031 1.438 1.031s1.202-0.445 1.406-1.031l4.844-8.75c0.499-0.963 0.781-2.06 0.781-3.2188 0-3.866-3.134-7-7-7zm-0.031 3.9688c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5 1.567-3.5 3.5-3.5z" fill="#e74c3c" transform="translate(0 1028.4)"/></g></svg>`,
  className: "",
  iconAnchor: [20, 40],
  iconSize: [40, 40],
});
const icons = {};
const fetchIcon = (count, size) => {
  if (!icons[count]) {
    icons[count] = L.divIcon({
      html: `<div class="cluster-marker" style="width: ${size}px; height: ${size}px;">
          ${count}
        </div>`,
    });
  }
  return icons[count];
};

const maxZoom = 17;

const MarkerCluster = ({
  points,
  bounds,
  zoom,
  markers,
  setBounds,
  setZoom,
}) => {
  const { clusters, supercluster } = useSupercluster({
    points: points,
    bounds: bounds,
    zoom: zoom,
    options: { radius: 75, maxZoom: maxZoom },
  });

  const map = useMap();
  const mapEvents = useMapEvents({
    zoomend: () => {
      updateMap();
    },
  });
  const updateMap = () => {
    const b = map.getBounds();
    setBounds([
      b.getSouthWest().lng,
      b.getSouthWest().lat,
      b.getNorthEast().lng,
      b.getNorthEast().lat,
    ]);
    setZoom(map.getZoom());
  };

  useEffect(() => {
    updateMap();
  }, [map]);

  return (
    <>
      {clusters &&
        clusters.map((cluster, index) => {
          const [longitude, latitude] = cluster.geometry.coordinates;
          const {
            cluster: isCluster,
            point_count: pointCount,
            facilityId,
          } = cluster.properties;
          if (isCluster) {
            return (
              <Marker
                key={`cluster-${cluster.id}`}
                position={[latitude, longitude]}
                icon={fetchIcon(
                  pointCount,
                  10 + (pointCount / points.length) * 40
                )}
                eventHandlers={{
                  click: (e) => {
                    const expansionZoom = Math.min(
                      supercluster.getClusterExpansionZoom(cluster.id),
                      maxZoom
                    );
                    map.setView([latitude, longitude], expansionZoom, {
                      animate: true,
                    });
                  },
                }}
              />
            );
          }
          return (
            <Marker
              key={`facility-${cluster.properties.facilityId}`}
              position={[latitude, longitude]}
              icon={markerIcon}
              eventHandlers={{
                click: (e) => {
                  markers
                    .find((marker) => marker.id === facilityId)
                    ?.onClick?.();
                },
              }}
            />
          );
        })}
    </>
  );
};

export default MarkerCluster;
